import Transform from "@ember-data/serializer/transform";

interface Deserialized {
  mimeType: string;
  index: number;
  data: string;
  fileContentAttributes: {
    data: string;
  };
  filename?: string;
}

interface Serialized {
  "mime-type": string;
  index: number;
  data: string;
  "file-content-attributes": {
    data: string;
  };
  filename?: string;
}

export default class FileAttachmentsTransform extends Transform {
  override deserialize(
    serialized: Serialized[] | undefined
  ): Deserialized[] | undefined {
    return serialized?.map(serializedItem => {
      return {
        mimeType: serializedItem["mime-type"],
        index: serializedItem["index"],
        data: serializedItem["data"],
        filename: serializedItem["filename"],
        fileContentAttributes: {
          data: serializedItem["file-content-attributes"]["data"]
        }
      };
    });
  }

  override serialize(
    deserialized: Deserialized[] | undefined
  ): Serialized[] | undefined {
    return deserialized?.map(deserializedItem => {
      return {
        "mime-type": deserializedItem.mimeType,
        index: deserializedItem.index,
        data: deserializedItem.data,
        filename: deserializedItem.filename,
        "file-content-attributes": {
          data: deserializedItem.fileContentAttributes.data
        }
      };
    });
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "file-attachments": FileAttachmentsTransform;
  }
}
